<template>
  <div style="margin-top:10px;background:#fff;overflow: hidden;border-radius: 5px;padding: 10px;">
    <div style="margin-bottom:10px;">
      <a-button type="danger" icon="plus" class="bt-button" style="float:right;" @click="$refs.editPlayer.show(null)">新增运动员</a-button>
      <a-select placeholder="请选择性别" style="width: 120px" :allowClear="true" v-model="queryParam.sex" @change="initChange">
        <a-select-option value="1"> 男 </a-select-option>
        <a-select-option value="2"> 女 </a-select-option>
      </a-select>
      <a-input-search placeholder="输入姓名、证件号搜索" v-model="queryParam.keyword" @change="initChange" style="width: 200px"/>
      <a-button type="primary" @click="resetQuery">重置</a-button>
      <span class="lesser">共计{{ total }}名运动员</span>
    </div>
    <a-table :columns="columns" :data-source="data" :rowKey='record=>record.id' bordered :pagination="false">
      <span slot="image" slot-scope="text, record">
        <img style="width:64px;height:64px;border-radius:5px;" :src="record.image" />
      </span>
      <span slot="sex" slot-scope="text">
        <a-tag color="purple" v-if="text === 0">未知</a-tag>
        <a-tag color="blue" v-if="text === 1">男</a-tag>
        <a-tag color="pink" v-if="text === 2">女</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button-group size="small">
          <a-button type="dashed" icon="edit" @click="$refs.editPlayer.show(record)">编辑</a-button>
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => deletePlayer(record.id)"
          >
            <a-button type="danger" icon="delete">删除</a-button>
          </a-popconfirm>
        </a-button-group>
      </span>
    </a-table>
    <a-pagination style="margin-top:10px;" v-if="data.length > 0" v-model="current" @change="pageData" :total="total" :pageSize="valData.pageSize" show-less-items />
    <EditPlayer ref="editPlayer" @ok="refreshAuth"/>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
import EditPlayer from './modal/EditPlayer'
export default {
  name: 'CenterAuth',
  components: {
    EditPlayer
  },
  created () {
    this.initList()
  },
  mounted () {},
  data () {
    return {
      matchFun: matchFun,
      valData: {
        agencyId: this.$route.query.agencyId,
        pageNum: 1,
        pageSize: 20,
        query: ''
      },
      queryParam: {},
      columns: [{
        title: '头像',
        dataIndex: 'image',
        align: 'center',
        scopedSlots: { customRender: 'image' }
      }, {
        title: '姓名',
        dataIndex: 'name',
        align: 'center'
      }, {
        title: '性别',
        dataIndex: 'sex',
        align: 'center',
        scopedSlots: { customRender: 'sex' }
      }, {
        title: '民族',
        align: 'center',
        dataIndex: 'nationality'
      }, {
        title: '出生日期',
        dataIndex: 'birthday',
        align: 'center'
      }, {
        title: '证件号',
        dataIndex: 'card',
        align: 'center'
      }, {
        title: '操作',
        align: 'center',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
      }],
      current: 1,
      data: [],
      total: 0
    }
  },
  methods: {
    initList () {
      this.valData.query = ''
      if (this.queryParam.sex || this.queryParam.keyword) {
        this.valData.query += '?'
        if (this.queryParam.sex) {
          this.valData.query += 'sex=' + this.queryParam.sex
        }
        if (this.queryParam.keyword) {
          if (this.valData.query !== '?') {
            this.valData.query += '&'
          }
          this.valData.query += 'keyword=' + this.queryParam.keyword
        }
      }
      this.$api.high.matchPlayerList(this.valData).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.total = res.total
        }
      }).catch(err => {
        console.log(err)
      })
    },
    pageData (pageNum) {
      this.valData.pageNum = pageNum
      this.initList()
    },
    initChange () {
      this.valData.pageNum = 1
      this.initList()
    },
    refreshAuth () {
      this.initList()
    },
    resetQuery () {
      this.valData = {
        agencyId: this.$route.query.agencyId,
        pageNum: 1,
        pageSize: 20,
        query: ''
      }
      this.queryParam = {}
      this.initList()
    },
    deletePlayer (id) {
      this.$api.match.playerDelete({id: id}).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.initList()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.BottomButton{
    margin: 50px 0;
    text-align: center;
    div{
        background-color: #d60701;
        padding: 10px 25px;
        width: 160px;
        color: #fff;
        margin: 0 auto;
        border-radius: 2px;
        cursor: pointer;
        text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/center/CenterPlayer.vue